module.exports = __webpack_public_path__ + "img/logo.e454199a.png";